import Navigation from "../Navigation";

const AppBar = () => {
  return (
    <header className="AppBar">
      <Navigation />
      <hr />
    </header>
  );
};

export default AppBar;
